import { useCallback, useState } from "react";
import type { PixelConfigResponse } from "@codway-dev/shared";
import { PixelService } from "../services/pixel.service";
import { fireClientTestEvent } from "../services/pixelTestClient";

/**
 * Drives the "Probar" button. Picks the firing leg(s) from the SAVED pixel's
 * mode (we test what's stored, not unsaved form edits):
 *   CLIENT_ONLY → client-side browser event (no provider ack → "verify in…")
 *   SERVER_ONLY → server-side event (real pass/fail from the provider)
 *   BOTH        → both; the server result drives the toast
 * All feedback goes through Shopify's toast, mirroring useShopifySaveBar.
 */
export function usePixelTest() {
  const [testing, setTesting] = useState(false);

  const runTest = useCallback(async (pixel: PixelConfigResponse) => {
    const firesClient = pixel.mode === "CLIENT_ONLY" || pixel.mode === "BOTH";
    const firesServer = pixel.mode === "SERVER_ONLY" || pixel.mode === "BOTH";

    setTesting(true);
    try {
      // Client leg first — synchronous fire-and-forget with no ack.
      if (firesClient) {
        fireClientTestEvent(pixel.provider, pixel.pixel_id);
      }

      if (firesServer) {
        const result = await PixelService.test(pixel.id);
        window.shopify?.toast?.show(result.message, {
          isError: !result.ok,
        });
      } else if (firesClient) {
        window.shopify?.toast?.show(
          "Evento de prueba enviado. Verifícalo en el administrador de eventos de tu proveedor."
        );
      }
    } catch (err) {
      window.shopify?.toast?.show(
        err instanceof Error
          ? err.message
          : "No se pudo enviar el evento de prueba",
        { isError: true }
      );
    } finally {
      setTesting(false);
    }
  }, []);

  return { testing, runTest };
}
